import styled from 'styled-components';

export const FiltersContainer = styled.div`
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 8px;
  background: #fff;
`;

export const NotesHint = styled.p`
  margin: 0 0 12px;
  color: #6a6c6e;
  font-size: 14px;
`;

export const NoteActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  width: 100%;

  button {
    white-space: nowrap;
  }
`;
